export default "__VITE_ASSET__CNOTI3N9__"